type SectionKey = "Parts" | "Expenses" | "Descriptions";

/**
 * Filter data for sections of service history expanded content by starting string which represents the section key.
 */

export const filterDataBySectionKey = <T extends object>(data: T[], sectionKey: SectionKey) => {
    return data.filter((item) =>
        Object.entries(item).some(([key, value]) => key.startsWith(sectionKey) && Boolean(value)),
    );
};
